import React, { Component } from "react";
import LogMainContainer from "../../../containers/activite/log/MainContainer";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import Menu from "../Menu";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftIndex("logs");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return <LogMainContainer />;
  }
}

const mapStateToProps = state => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/admin/logs/Home.log.js